import {
  Spin, Col, Card, Tag, Table, Row,
} from 'antd';
import { useLocation } from 'react-router-dom';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import qs from 'query-string';
import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import FileDownload from '@/components/FileDownload/FileDownload';
import { getAgrProductDetail, getBillionProductDetail } from '@/services/projectScheduling';
import './index.less';
import { getDictType } from '@/services/common';
import { XMDD_ARG_PRO } from '@/utils/mappingDict';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';
import EquipmentExpandTable from './EquipmentExpandTable';

const obj = {
  0: 'processing', 2: 'error', 9: 'cancel', 1: 'success', // status 为0正常状态，进行中UI为实心数字； 1 拒绝； 2取消； 3：所有流程完成
};
const level = {
  1: '省级',
  2: '市级',
  3: '县级',
};
const currentYear = dayjs().year(); // 当前年份
export default function ProjectSchedulingDetail() {
  const { search } = useLocation();
  const { id, type } = qs.parse(search);
  const [data, setData] = useState({});

  const { data: dict = {} } = useRequest(getDictType, { defaultParams: [XMDD_ARG_PRO] });

  const { loading, run: agrRun } = useRequest(() => getAgrProductDetail(id), {
    manual: true,
    onSuccess(res) {
      setData(res);
    },
  });

  const { loading: loading1, run: billionRun } = useRequest(() => getBillionProductDetail(id), {
    manual: true,
    onSuccess(res) {
      setData(res);
    },
  });

  useEffect(() => {
    if (type === '1') {
      agrRun();
    } else {
      billionRun();
    }
  }, []);

  function getIcon(status, index) {
    if (status === 0) {
      return index;
    } if (status === 2 || status === 9) {
      return <CloseOutlined />;
    }
    return <CheckOutlined />;
  }

  const columns = [
    {
      title: '子项名称',
      dataIndex: 'subProjectName',
      width: 180,
      render: (text, record) => {
        const targetStr = type === '1' && record.subProjectCode;
        return (
          <div>
            {targetStr ? (
              <DictionaryMatching value={record.subProjectCode} dictionary={dict[XMDD_ARG_PRO]} />
            ) : (
              <span>{text}</span>
            )}
          </div>
        );
      },
    },
    {
      title: '建设内容',
      dataIndex: 'constructionContent',
    },
    {
      title: type === '1' ? '项目计划投资(万元)' : '承担建设内容投资(万元)',
      dataIndex: 'investment',
    },
    {
      title: '已完成投资(万元)',
      dataIndex: 'investmentCompleted',
    },
    {
      title: '申报财政补助资金(万元)',
      dataIndex: 'financialAidAmount',
    },
  ];
  const initiationYear = Number(data?.initiationYear);
  const yearList = [
    // { key: 'beforeLastYearRevenue', key2: 'beforeLastYearOutputValue', value: initiationYear - 2 },
    {
      key: 'lastYearRevenue', key2: 'lastYearOutputValue', key3: 'chainOwnerLastYearRevenue', value: initiationYear - 1,
    },
    {
      key: 'currentYearRevenue', key2: 'currentYearOutputValue', key3: 'chainOwnerCurrentYearRevenue', value: initiationYear,
    },
    {
      key: 'nextYearRevenue', key2: 'nextYearOutputValue', key3: 'chainOwnerNextYearRevenue', value: initiationYear + 1,
    },
  ];
  return (
    <div className="project-scheduling-detail">
        <div className="content-width">
          <Spin spinning={loading || loading1}>
          <Card title="项目信息">
            <div className="myapplication-detail__grid">
              <div>
                立项年度：
                {data?.initiationYear}
              </div>
              <div hidden={type === '1'}>
                所属产业链：
                {data?.projectChain}
              </div>
              <div>
                项目名称：
                {data?.projectName}
              </div>
              <div>
                项目所属区域：
                {`${data?.projectProvinceCode}-${data?.projectCityCode}-${data?.projectAreaCode}`}
              </div>
              <div style={{ display: 'flex' }}>
                <div style={{ flexShrink: 0 }}>项目建设现场照片：</div>
                <div>
                  {data?.fileVos?.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <FileDownload key={index} appendixName={item.fileName} fileUrl={item.fileUrl} />
                  ))}
                </div>
              </div>
              <div>
                新建农产品产地初加工和商品化处理设施（座）：
                {data?.newBuiltNum}
              </div>
              <div>
                {type === '1' ? '项目计划总投资' : '承担建设内容总投资'}
                （万元）：
                {data?.totalInvestment}
              </div>
              <div>
                已完成总投资（万元）：
                {data?.totalInvestmentCompleted}
              </div>
              <div>
                申报财政补助资金总额（万元）：
                {data?.totalFinancialAidAmount}
              </div>
            </div>
            <div style={{ marginTop: 12 }}>
              <div style={{ flexShrink: 0 }}>项目资金使用情况表：</div>
              <div>
                <Table
                  size="small"
                  rowKey={(row, index) => String(index)}
                  columns={type === '1' ? columns : columns.filter((item) => item.dataIndex !== 'constructionContent')}
                  dataSource={data.fundUtilizationVos}
                  pagination={false}
                  scroll={{ y: 500 }}
                  expandable={{
                    // eslint-disable-next-line react/no-unstable-nested-components
                    expandedRowRender: (record) => (
                      <EquipmentExpandTable data={record.specialAgriculturalFundsEquips || []} />
                    ),
                    rowExpandable: (record) => !isEmpty(record.specialAgriculturalFundsEquips),
                  }}
                />
              </div>
            </div>
          </Card>
          <Card title="企业信息" style={{ marginTop: 10 }} hidden={type !== '1'}>
            <div className="myapplication-detail__grid">
              <div>
                企业名称：
                {data?.applicantName}
              </div>
              <div>
                统一社会信用代码:
                {data?.applicantNo}
              </div>
              <div>
                企业所属区域：
                {`${data?.provinceCode}-${data?.cityCode}-${data?.areaCode}`}
              </div>
              <div>
                是否有需要解决问题：
                {data?.problemTbr === 1 ? '是' : '否'}
              </div>
              {
                yearList.map((item) => {
                  const isShow = item.value <= currentYear;
                  return (
                    isShow && (
                      <>
                        <div>
                          企业
                          {item.value}
                          年营业收入(万元)：
                          {data?.[item.key]}
                        </div>
                        <div>
                          企业
                          {item.value}
                          年产值(万元)：
                          {data?.[item.key2]}
                        </div>
                      </>
                    )
                  );
                })
              }
            </div>
          </Card>
          <Card title="主体信息" style={{ marginTop: 10 }} hidden={type === '1'}>
            <div className="myapplication-detail__grid">
              <div>
                主体名称：
                {data?.applicantName}
              </div>
              <div>
                统一社会信用代码/身份证号码：
                {data?.applicantNo}
              </div>
              <div>
                主体所属区域：
                {`${data?.provinceCode}-${data?.cityCode}-${data?.areaCode}`}
              </div>
              <div>
                是否有需要解决问题：
                {data?.problemTbr === 1 ? '是' : '否'}
              </div>
              <div>
                是否为链主企业：
                {data?.chainOwner === 1 ? '是' : '否'}
              </div>
              {
                data?.chainOwner === 1 && yearList.map((item) => {
                  const isShow = item.value <= currentYear;
                  return (
                    <div key={item.value} hidden={!isShow}>
                      链主企业
                      {item.value}
                      年营业收入(万元)：
                      {data?.[item.key3]}
                    </div>
                  );
                })
              }
            </div>
          </Card>
          <Card
            title={(
              <div>
                <span style={{ marginRight: 10 }}>需要协助解决问题</span>
                <Tag color="processing" hidden={data?.problemStatus !== 1}>已解决</Tag>
                <Tag color="error" hidden={data?.problemStatus !== 2}>无法解决</Tag>
                <Tag color="warning" hidden={data?.problemStatus !== 0}>待处理</Tag>
              </div>
            )}
            style={{ marginTop: 10 }}
            hidden={data?.problemTbr !== 1}
          >
            <Row className="problem-row">
              <Col span={12}>
                农业部门级别：
                {level?.[data?.agricultureDeptLevel]}
              </Col>
              <Col span={12}>
                { type === '1' ? '企业联系方式：' : '主体联系方式：' }
                {data?.contactPhone}
              </Col>
              <Col span={24}>
                问题描述：
                {data?.problemDescription}
              </Col>
              <Col span={24}>
                处理部门级别：
                {level?.[data?.solveDeptLevel]}
              </Col>
              <Col span={12}>
                农业部门联系人：
                {data?.solveContactPerson}
              </Col>
              <Col span={12}>
                农业部门联系方式：
                {data?.solveContactPhone}
              </Col>
              <Col span={24}>
                解决方案/原因：
                {data?.remark}
              </Col>
            </Row>
          </Card>
          <div className="myapplication-detail__sub-title">状态</div>
          <div className="major-project-timeline">
            {
              data?.userLogs?.map((item, index) => (
                <div className={`timeline-item timeline-item-${index + 1 === data?.userLogs.length && obj?.[item.status]}`}>
                  <div className="timeline-icon">
                    {
                      index + 1 === data?.userLogs.length
                        ? (
                          <>
                            {getIcon(item.status, index + 1)}
                          </>
                        ) : <CheckOutlined />
                    }
                  </div>
                  <div className="timeline-cont">
                    <div className="timeline-title">{item.title}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.remark }} />
                    <div>{item.operateTime}</div>
                  </div>

                </div>
              ))
            }
          </div>
          </Spin>
        </div>
    </div>
  );
}
